var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrowinline = function SvgRightArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: "100%",
      height: "100%"
    },
    viewBox: "0 0 10 11",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rightArrow_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "m4.25 2.729 3.323 3.323a.25.25 0 0 1 0 .353L4.25 9.73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rightArrow_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h10v10H0z"
  })))));
};
export default SvgRightArrowinline;